<div class="relative w-fit">
  <aux-button
    class="column-chooser-button"
    [variant]="isColumnChooserApplied() ? 'primary' : 'secondary'"
    label=""
    icon="Columns3"
    [disabled]="disabled()"
    (click)="onOpenColumnChooser()"
    [auxTooltip]="'Column Chooser'"
    [auxTooltipPositions]="[
      {
        offsetY: 8,
        originX: 'center',
        originY: 'bottom',
        overlayX: 'center',
        overlayY: 'top',
      },
    ]"
  />

  @if (showThereArePinnedColumnsIndicator()) {
    <div
      class="absolute -right-[10px] -top-[10px] flex size-[20px] items-center justify-center rounded-full border border-aux-blue bg-white text-xs text-aux-blue-dark shadow"
    >
      <aux-icon name="Pinned" class="!fill-aux-blue-dark" [size]="14" />
    </div>
  }
</div>
